module.exports = require('./react-image-lightbox').default;



// WEBPACK FOOTER //
// ./src/index.js